<template>
    <validation-observer ref="observer" v-slot="{ passes }">
        <b-form-group>
            <b-input-group prepend="Decursus">
            <b-form-select id="decursus_id" name="decursus_id" plain v-model="form.decursus">
                <b-form-select-option :value="null">* Select Decursus</b-form-select-option>
                <b-form-select-option v-for="decursus_item in decursus" :key="decursus_item.id" :value="decursus_item.id">{{ toLocaleDate(decursus_item.date) }}
                </b-form-select-option>
            </b-form-select>
            </b-input-group>
        </b-form-group>

        <b-form-group :disabled="!decursusSelected">
            <template slot="description">
                <span v-show="!filterByInsurance" class="text-danger">No primary active insurance.</span>
            </template>

            <vue-bootstrap-autocomplete prepend="Procedure" v-model="query" :data="items" placeholder="Search..." :minMatchingChars="1" :serializer="itemSerializer" @hit="onHit" @input="lookupItem">
                <template slot="suggestion" slot-scope="{ data, htmlText }">
                    <div>
                        <!-- Note: the v-html binding is used, as htmlText contains
                        the suggestion text highlighted with <strong> tags -->                                    
                        <div class="d-flex w-100 justify-content-between">
                            <small class="ml-1">{{ data.code }}</small>
                            <small class="ml-auto">{{ data.resource }} - {{ data.tariff }}</small>
                        </div>
                        
                        <small class="ml-1" v-html="htmlText"></small>

                    </div>
                </template>
            </vue-bootstrap-autocomplete>
        </b-form-group>
    </validation-observer>
</template>
<script>
import FormExtension from '@/core/components/FormExtension'
import { mapGetters, mapState, mapActions } from "vuex"
import debounce from 'lodash/debounce'

export default FormExtension.extend({
    name: 'procedures-form',
    data() {
        return {
            form: new Form({
                decursus: null,
                description: "",
                type_id: null,
                consistency_token: null
            }),

            items: [],
            query: "",
        }
    },
    computed: {
        ...mapGetters('patients', ['getPatientDecursus']),
        decursus() {
            return this.getPatientDecursus()
        },
        ...mapGetters('insurances', ['getPrimaryInsurance']),
        primary() {
            return this.getPrimaryInsurance()
        },
        activeInsurance() {
            return this.primary ? this.primary.is_active : false
        },
        insurance() {
            if (this.activeInsurance) {
                return this.primary.company?.name === "SZF" ? "SZF" : "SURVAM"
            }

            return false
        },
        filterByInsurance() {
            return this.insurance || false
        },
        decursusSelected() {
            return this.form.decursus !== null
        }
    },
    methods: {
        ...mapActions('procedures', ['filterProcedures']),
        ...mapActions('patients', ['getDecursusForCurrentPatient']),
        ...mapActions('insurances', ['getInsurancesForCurrentPatient']),

        async loadForPatient(patient) {
            await this.getDecursusForCurrentPatient()
            await this.getInsurancesForCurrentPatient()
        },
        itemSerializer(item) {
            return item.name
        },
        onHit(item) {
            this.form.populate({type_id:  item.id})
            this.save()
        },
        save() {
            this.callback(this.form.data()).then(() => {
                this.reset()
            })
            .catch(errors => {
                if (errors.response) {
                    this.notify("Error", "Something went wrong", 'danger')
                    this.hasErrors = true
                }
            })
        },
        lookupItem: debounce(function () {
            this.filterProcedures({ search: this.query })
                .then((items) => {
                    if (this.filterByInsurance) {
                        const filtered = items.filter(item => item.resource == this.filterByInsurance)
                        this.items = filtered.length > 0 ? filtered : items
                    }else{
                        this.items = items
                    }
            })
        }, 500),
        reset() {
            this.query = ""
            this.form.reset()
        },
    }
})
</script>